module.exports = __webpack_public_path__ + "img/Wing_feathers_Normal.612f0f0.png";